function hasAccess(permissions, permission) {
  if (permissions.indexOf('master') !== -1) return true;
  if (permissions.indexOf(permission) !== -1) return true;
}

export default {
  hasAccess,
};
